import { portal } from '../../assets/plugins/axios/axios';

export const GetMessagesForThread = Object.freeze({
  url: '?method=messaging.getMessagesForThread',
  getMessagesForThread: config => portal.get(GetMessagesForThread.url, config),
});
